import { render } from "./device-config.vue?vue&type=template&id=3345dca5&scoped=true"
import script from "./device-config.vue?vue&type=script&lang=js"
export * from "./device-config.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3345dca5"

export default script